import * as React from "react";
import ReactSpeedometer from "react-d3-speedometer";

interface IProps {
    creditScore: number;
}
function CreditMeter(props: IProps) {
    return configureMeterValue(Math.floor(props.creditScore));
}
function configureMeterValue(score: number) {
    return <ReactSpeedometer
        maxValue={100}
        value={score}
        needleHeightRatio={0.8}
        needleColor="#000000"
        height={screen.width < 400 ? 160 : 190}
        width={screen.width < 400 ? 260 : 300}
        segments={5}
        paddingHorizontal={5}
        paddingVertical={3}
        ringWidth={35}
        segmentColors={["#E17454", "#E9A144", "#EDE563", "#C0E448", "#40CA3D"]}
    />;
}
export default CreditMeter;
